/* jshint node:true */
'use strict';

/*
    Action:     Output the desired div placeholder for the adverts
    Original:   /tea/core-tea/redesign/src/main/tea/format/modules/ads/ad.tea
    Orginator:  ben.hobden@espn.com
*/

var React           = require('react');
var classNames      = require('classnames');

var Advert = React.createClass({

    displayName: 'Advert',
    
    count : 1,

    render: function () {

        var sInview             = this.props.inView || null;
        var sClassName          = this.props.className || null;
        var bCollapseBeforeLoad = this.props.collapseBeforeLoad === true ? true : false;
        var bRefreshIfVisible   = this.props.refreshIfVisible === true ? true : false;
        var bIsOutOfPage        = this.props.isOutOfPage === true ? true : false;
        var sSlotType           = this.props.slotType || null;
        var aInclude            = this.props.include || [];
        var aExclude            = this.props.exclude || [];
        var hKVPs               = this.props.kvps || {};
        var props               = { id: this.props.id || 'react-ad_' + this.count++ };
        var aClasses            = ['react-ad'];
        var aSlotKvps           = [];
        var bAddDefault         = true;

        /* TODO: add in ad block module see related tea file. */

        /* no type no advert */
        if(sSlotType === null) {
            return null;
        }

        if(sInview === null ){
        	aClasses.push('ad-slot');
        }

        if(sClassName !== null) {
        	aClasses.push(sClassName);
        }

        /* default if pos not specified */
        if(typeof hKVPs.pos === "undefined") {
        	hKVPs.pos=sSlotType;
        }

        /* build key value pair string */
        for (var sKey in hKVPs) {
        	if(sKey !== null && hKVPs.sKey !== null) {
        		aSlotKvps.push(sKey+"="+hKVPs[sKey]);
        	}
        }

        /* build up the div properties */
        props.className = classNames(aClasses);
        props['data-slot-type'] = sSlotType;

        if(bIsOutOfPage === true) {
        	props['data-out-of-page'] = "true";
        }

        if(bRefreshIfVisible === true ){
        	props['data-refresh-if-visible'] = "true";
        }

        if(bCollapseBeforeLoad === true) {
        	props['data-collapse-before-load'] = "true";
        }

    	if(aInclude.length > 0) {
    		var sIncludeStr = aInclude.join(",");
    		props['data-include-bp'] = sIncludeStr;
    	}

    	if(aExclude.length > 0) {
    		var sExcludeStr = aExclude.join(",");
    		props['data-exclude-bp'] = sExcludeStr;
    	}

    	if(aSlotKvps.length > 0) {
    		var sKvpsStr = aSlotKvps.join(",");
    		props['data-slot-kvps'] = sKvpsStr;
    	}

        return (
            <div {...props} />
        );
    }
});

module.exports = Advert;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/common/Advert.jsx
 **/